module.exports = __webpack_public_path__ + "static/horned_devil-e6d4827c5bda9f9a40ca69ef2c86bc5f.jpeg";